import Vue from "vue"; 
import Main from "./main.vue";

let ToastConstructor = Vue.extend(Main);
let instance;

const Toast = function(options = {}) {
  instance = new ToastConstructor({
    data:options
  }); // 渲染组件
  document.body.appendChild(instance.$mount().$el); // 挂载到 body 下
};

export default Toast;


// WEBPACK FOOTER //
// ./src/components/toast/main.js